import type { PcsEventDto } from '../../../app/models/events/pcsEventDto';
import type { PcsEventInstanceDto } from '../../../app/models/events/pcsEventInstanceDto';
import type { GetPcsEventDocumentParamObj } from '../common/getPcsEventDocumentParam';
import { requests } from '../../../app/api/httpClient';

export const PcsEvent = {
    gePcsEventsAsync: () => requests.get(`PcsEvent`),
    gePcsEventByIdAsync: (id: string) => requests.get(`PcsEvent/${id}`),
    savePcsEventAsync: (data: PcsEventDto) => requests.post(`PcsEvent`, data),
    updatePcsEventAsync: (data: PcsEventDto) => requests.put(`PcsEvent`, data),
    submitPcsEventAsync: (eventId: string) => requests.put(`PcsEvent/Submit`, { eventId: eventId }),
    getPcsEventInstancesAsync: (id: string) => requests.get(`PcsEvent/${id}/Instances`),
    savePcsEventInstanceAsync: (data: PcsEventInstanceDto) => requests.post(`PcsEvent/Instance`, data),
    getPcsEventDocumentsAsync: (id: string) => requests.get(`PcsEvent/${id}/Documents`),
    getPcsEventDocumentAsync: (getPcsEventDocumentParamObj: GetPcsEventDocumentParamObj) =>
        requests.getConfig<Blob>(`PcsEvent/${getPcsEventDocumentParamObj.eventId}/Document/${getPcsEventDocumentParamObj.fileName}`,
            { responseType: 'blob' }),
    savePcsEventDocumentAsync: (data: FormData) => requests.post(`PcsEvent/Document`, data, {
        headers: {
            "content-type": "multipart/form-data"
        }
    }),
    deleteDocumentAsync: (getPcsEventDocumentParamObj: GetPcsEventDocumentParamObj) =>
        requests.delete(`PcsEvent/${getPcsEventDocumentParamObj.eventId}/Document/${getPcsEventDocumentParamObj.fileName}`)
};
